var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 100,
    viewBox: "0 0 122 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11708",
    x: 14.7372,
    y: 17.1636,
    width: 91.8953,
    height: 73.9586,
    fill: "#F2E6C9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11712",
    x: 23.4299,
    y: 30.582,
    width: 41.2908,
    height: 47.1213,
    fill: "#F5F9F1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11709",
    x: 24.9823,
    y: 37.7595,
    width: 38.1862,
    height: 37.7595,
    fill: "#AAD5D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.885 75.4369V76.205L63.2195 76.2112V75.4248L24.885 75.4369Z",
    fill: "#BBBBBB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6766 86.3516V95.9085H109.015V86.3516H12.6766Z",
    fill: "#11BB8D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11710",
    x: 72.7927,
    y: 37.7595,
    width: 28.8725,
    height: 58.0435,
    fill: "#F5F9F1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11711",
    x: 76.5181,
    y: 37.7595,
    width: 21.732,
    height: 56.1711,
    fill: "#AAD5D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M99.9642 62.3086V66.1551H74.2917V62.3086H99.9642Z",
    fill: "#F5E6C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M83.8592 63.8687V64.5946H76.4261V63.8687H83.8592Z",
    fill: "#FEFEF6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1.94031 95.7087V99.8045H120.06V95.7087H1.94031Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0 98.8298V100H122V98.8298H0Z",
    fill: "#79747E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.2356 34.0593V41.5049C10.2356 41.5049 10.3313 48.1667 18.5105 48.1667C26.6898 48.1667 26.6898 41.5049 26.6898 41.5049V34.0593H10.2356Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.9525 33.8787V41.3616C25.9525 41.3616 26.0006 48.0568 33.1559 48.0568C40.3112 48.0568 40.3112 41.3616 40.3112 41.3616V33.8787H25.9525Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M54.2814 34.1018V41.6438C54.2814 41.6438 54.2814 48.3918 47.1021 48.3918C39.9227 48.3918 39.9227 41.6438 39.9227 41.6438V34.1018H54.2814Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M53.6992 34.1396V41.7677C53.6992 41.7677 53.7598 48.5928 60.9573 48.5928C68.1549 48.5928 68.1549 41.7677 68.1549 41.7677V34.1396H53.6992Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M82.0285 34.1865V41.9206C82.0285 41.9206 82.0285 48.8406 74.8977 48.8406C67.7668 48.8406 67.7668 41.9206 67.7668 41.9206V34.1865H82.0285Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M81.6408 34.23V42.0629C81.6408 42.0629 81.6889 49.0713 88.8442 49.0713C95.9995 49.0713 95.9995 42.0629 95.9995 42.0629V34.23H81.6408Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M112.609 34.262V42.1676C112.609 42.1676 112.665 49.241 104.138 49.241C95.6113 49.241 95.6113 42.1676 95.6113 42.1676V34.262H112.609Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M8.52808 30.7285V38.1741C8.52808 38.1741 8.62373 44.8359 16.8031 44.8359C24.9824 44.8359 24.9824 38.1741 24.9824 38.1741V30.7285H8.52808Z",
    fill: "#11BB8D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M24.9823 30.728V38.2109C24.9823 38.2109 25.0304 44.9062 32.1857 44.9062C39.3409 44.9062 39.3409 38.2109 39.3409 38.2109V30.728H24.9823Z",
    fill: "#DFE2EB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M53.6992 30.7278V38.2697C53.6992 38.2697 53.6992 45.0178 46.5199 45.0178C39.3406 45.0178 39.3406 38.2697 39.3406 38.2697V30.7278H53.6992Z",
    fill: "#11BB8D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M53.6992 30.7271V38.3551C53.6992 38.3551 53.7598 45.1802 60.9573 45.1802C68.1549 45.1802 68.1549 38.3551 68.1549 38.3551V30.7271H53.6992Z",
    fill: "#DFE2EB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M82.4165 30.7263V38.4604C82.4165 38.4604 82.4165 45.3804 75.2857 45.3804C68.1549 45.3804 68.1549 38.4604 68.1549 38.4604V30.7263H82.4165Z",
    fill: "#11BB8D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M82.4169 30.7256V38.5585C82.4169 38.5585 82.4651 45.5669 89.6203 45.5669C96.7756 45.5669 96.7756 38.5585 96.7756 38.5585V30.7256H82.4169Z",
    fill: "#DFE2EB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M114.394 30.7253V38.6309C114.394 38.6309 114.45 45.7044 105.923 45.7044C97.3965 45.7044 97.3965 38.6309 97.3965 38.6309V30.7253H114.394Z",
    fill: "#11BB8D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M31.5796 6.00732H18.6677L8.52808 30.8989H24.4502L31.5796 6.00732Z",
    fill: "#11BB8D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M31.4825 6.00732H43.2217L39.341 30.8989H24.9338L31.4825 6.00732Z",
    fill: "#FEFEF4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M55.0574 6.00732H43.1242L39.2435 30.8989H53.7477L55.0574 6.00732Z",
    fill: "#11BB8D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M54.9609 6.00732H66.8456L68.2283 30.8989H53.6511L54.9609 6.00732Z",
    fill: "#FEFEF4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M78.6569 6.00732H66.7482L68.1309 30.8989H82.4895L78.6569 6.00732Z",
    fill: "#11BB8D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M78.5603 6.00732H90.3965L96.8241 30.8989H82.3929L78.5603 6.00732Z",
    fill: "#FEFEF4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M103.856 6.00732H90.2995L97.5718 30.8989H114.394L103.856 6.00732Z",
    fill: "#11BB8D"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11712_2",
    x: 8.52808,
    y: 29.958,
    width: 105.866,
    height: 1.87237,
    fill: "#F5F9F1",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M18.7488 3.08179V6.00737H103.154V3.08179H18.7488Z",
    fill: "#F5E6C6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M104.149 0V6.01653H18.7731V0H104.149Z",
    fill: "#11BB8D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M104.149 5.58936V6.05863H18.7731V5.58936H104.149Z",
    fill: "#11BB8D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.c719d926f61c9ab96ef8a3fe1038a056.svg";
export { ForwardRef as ReactComponent };